import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function ContactForm() {
  const [status, setStatus] = useState(null);
  const [searchParams] = useSearchParams();

  const getInitialSubject = () => {
    const subjectParam = searchParams.get('emne') || searchParams.get('subject');
    if (!subjectParam) return 'Generel henvendelse';
    const normalized = subjectParam.toLowerCase().trim();
    if (normalized.includes('interim')) return 'Interim opgaver';
    if (normalized.includes('full')) return 'Full service';
    if (normalized.includes('økonomisk') || normalized.includes('okonomisk')) return 'Økonomisk rådgivning';
    if (normalized.includes('juridisk')) return 'Juridisk rådgivning';
    return 'Generel henvendelse';
  };

  const [subject, setSubject] = useState(getInitialSubject());

  useEffect(() => {
    setSubject(getInitialSubject());
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    try {
      const response = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setStatus('success');
        e.target.reset();
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="bg-slate-50 p-8 rounded-sm shadow-sm border border-slate-200">
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Antispam Honeypot */}
        <div className="sr-only absolute" aria-hidden="true">
          <label htmlFor="website_url">Website URL</label>
          <input type="text" id="website_url" name="website_url" tabIndex="-1" autoComplete="off" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-1">Navn</label>
            <input
              type="text"
              name="name"
              id="name"
              required
              className="block w-full rounded-sm border-slate-300 bg-white px-4 py-2 text-slate-900 shadow-sm focus:border-[#876a57] focus:ring-[#876a57] outline-none border transition-all"
            />
          </div>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-1">E-mail</label>
            <input
              type="email"
              name="email"
              id="email"
              required
              className="block w-full rounded-sm border-slate-300 bg-white px-4 py-2 text-slate-900 shadow-sm focus:border-[#876a57] focus:ring-[#876a57] outline-none border transition-all"
            />
          </div>
        </div>

        <div>
          <label htmlFor="subject" className="block text-sm font-medium text-slate-700 mb-1">Emne</label>
          <select
            name="subject"
            id="subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className="block w-full rounded-sm border-slate-300 bg-white px-4 py-2 text-slate-900 shadow-sm focus:border-[#876a57] focus:ring-[#876a57] outline-none border transition-all"
          >
            <option value="Generel henvendelse">Generel henvendelse</option>
            <option value="Interim opgaver">Interim opgaver</option>
            <option value="Full service">Full service</option>
            <option value="Økonomisk rådgivning">Økonomisk rådgivning</option>
            <option value="Juridisk rådgivning">Juridisk rådgivning</option>
          </select>
        </div>

        <div>
          <label htmlFor="message" className="block text-sm font-medium text-slate-700 mb-1">Besked</label>
          <textarea
            name="message"
            id="message"
            rows="4"
            required
            className="block w-full rounded-sm border-slate-300 bg-white px-4 py-2 text-slate-900 shadow-sm focus:border-[#876a57] focus:ring-[#876a57] outline-none border transition-all"
          ></textarea>
        </div>

        <button
          type="submit"
          disabled={status === 'sending'}
          className="cta-button w-full disabled:opacity-50"
        >
          {status === 'sending' ? 'Sender...' : 'Send besked'}
        </button>

        {status === 'success' && (
          <p className="text-green-600 text-sm font-medium mt-2">Tak for din besked! Vi vender tilbage til dig hurtigst muligt.</p>
        )}
        {status === 'error' && (
          <p className="text-red-600 text-sm font-medium mt-2">Der skete en fejl. Prøv venligst igen eller kontakt os direkte.</p>
        )}
      </form>
    </div>
  );
}
